<div>
  <ng-template [ngIf]="atti && atti?.length > 0">
    <div class="row">
      <p class="col-sm-3 ordina_data" style="position:unset">
        <label for="cerca-atti-list-v">Cerca</label> <input class="form-control"
          #searchItem (keyup)="0" id="cerca-atti-list-v" placeholder="Inserisci"
          type="text">
      </p>
      <p class="col-sm-3 col-md-offset-6">
        <label for="ordina_data-atti-list">Ordina per:</label> <select
          class="form-control" id="ordina_data-atti-list" #orderByValue (change)="0">
          <option value="dataNotifica:ASC">Data notifica crescente</option>
          <option value="dataNotifica:DESC">Data notifica
            decrescente</option>
          <option value="tipoAtto.descrizione:ASC">Tipo Atto</option>
        </select>
      </p>
    </div>
    <ul class="atti">
      <ng-template ngFor let-atto [ngForOf]="atti | searchFilter : searchItem.value : 'tipoAtto.descrizione+note' | orderBy : orderByValue.value" let-i=index>
        <li>

          <div>
            <div *ngIf="!hasAssociaButton" class="row atti-row" style="margin: 10px">
              <p class="col-sm-4 col-md-5">
                <strong>{{atto && atto.tipoAtto ? atto.tipoAtto.descrizione : ''}}</strong>
              </p>
              <p class="col-sm-2 col-md-2">
                <strong>{{atto && atto.provenienza ? atto.provenienza.descrizione : ''}}</strong>
              </p>
              <p class="col-sm-2 col-md-4">
                Data Notifica: <strong>{{ atto.dataNotifica ?
                  (atto.dataNotifica | date:'dd/MM/yyyy'): '' }}</strong>
              </p>
              <!--<p class="col-sm-3 col-md-3">
                N&deg; protocollo: <strong>{{ atto.numeroProtocollo ?
                  atto.numeroProtocollo: '' }}</strong>
              </p> -->
              <div class="col-sm-2 col-md-2">
                <div class="data_opzioni">
                  <ul>
                    <li *ngIf="writable" class="opzioni" appDropdownFocus><a class="dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
                        aria-expanded="true">Opzioni<span class="glyphicon glyphicon-option-vertical"></span></a>
                      <div class="dropdown-menu">
                        <ul>
                          <li>
                            <span class="glyphicon glyphicon-paperclip"></span>
                            <a href="javascript:void(0);" (click)="onClickDropDownEvent({eventType: 'allegato', index: i, atto: atto})">
                              Allega documento
                            </a>
                          </li>

                          <li>
                            <span class="glyphicon glyphicon-trash"></span>
                            <a href="javascript:void(0)" (click)="onDelete({atto: atto, index: i})">Elimina</a>
                          </li>

                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
                </div>
                <div class="col-sm-1 col-md-1">
                    <a
                      href="#"
                      role="button"
                      class="collapsed"
                      [class.accordion-collapse]="activeIndex === i"
                      [class.accordion-collapsed]="activeIndex !== i"
                      [attr.aria-expanded]="activeIndex === i"
                      [attr.aria-controls]="'subcontroparteModalAdd' + i"
                      id="accordion-header-atti-{{i}}"
                      (click)="openDetail(atto, i); $event.preventDefault()">
                        <span aria-live="polite" class="sr-only">{{ activeIndex === i ? 'Chiudi dettaglio' : 'Apri dettaglio' }}</span>
                    </a>
                </div>
            </div>

            <div *ngIf="hasAssociaButton" class="row atti-row" style="margin: 10px">
              <p class="col-sm-2 button-associa">
                <button [disabled]="associaDisabled" class="btn btn-primary associa"
                  (click)="onAssocia(i)">Associa</button>
              </p>
              <p class="col-sm-4">
                <strong>{{ atto.tipoAtto.label }}</strong>
              </p>
              <p class="col-sm-3">
                Data pubblicazione<br> <strong>{{ atto.dataPubblicazione ?
                  (atto.dataPubblicazione | date:'dd/MM/yyyy'): '' }}</strong>
              </p>
              <p class="col-sm-3">
                Data deposito<br> <strong>{{ atto.dataDeposito ?
                  (atto.dataDeposito | date:'dd/MM/yyyy'): '' }}</strong>
              </p>
            </div>
          </div>
          <!--<div class="atti-content">
            <ngb-accordion #acc="ngbAccordion">
              <ngb-panel id="attolistmember{{ i }}">
                <ng-template ngbPanelContent>
                  <form *ngIf="!hasAssociaButton">
                    <div class="data_opzioni">
                      <a href="javascript:void(0)" (click)="onEdit(i)" *ngIf="hasEditButton">
                        <span class="glyphicon glyphicon-pencil"></span>
                      </a>
                    </div>
                    <div class="row">

                      <div labelTextInput class="col-sm-12 bloccodati" [typeLabel]="'text'"
                        [labelInput]="'Tipo atto'" [valueInput]="atto.tipoAtto?.descrizione"></div>
                    </div>
                    <div class="row">
                      <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
                        [labelInput]="'Provenienza'" [valueInput]="atto.provenienza?.descrizione"></div>
                      <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'date'"
                        [labelInput]="'Data deposito'" [valueInput]="atto.dataDeposito"></div>
                      <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'date'"
                        [labelInput]="'Data notifica'" [valueInput]="atto.dataNotifica"></div>
                    </div>
                    <div class="row">
                      <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'boolean'"
                        [labelInput]="'Titolo esecutivo'" [valueInput]="atto.titoloEsecutivo"></div>
                      <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'date'"
                        [labelInput]="'Data apposizione formula esecutiva'"
                        [valueInput]="atto.dataApposizioneFormulaEsecutiva"></div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12 bloccodati">
                        <p>
                          <label class="col-sm-12">Note</label> <span class="longtext">{{ atto.note
                            }}</span>
                        </p>
                      </div>
                    </div>
                  </form>
                </ng-template>
              </ngb-panel>
            </ngb-accordion>
          </div>-->
          <ul class="{{activeIndex === i ? 'collapsed' : 'collapse'}} subcontroparte">
            <li>
              <form *ngIf="!hasAssociaButton">
                <div class="row">
                  <div labelTextInput class="col-sm-12 bloccodati" [typeLabel]="'text'" [labelInput]="'Tipo atto'"
                    [valueInput]="atto.tipoAtto?.descrizione"></div>
                  <!-- <div class="col-sm-1">
                    <a href="javascript:void(0)" (click)="onEdit(i)" *ngIf="hasEditButton">
                      <span class="glyphicon glyphicon-pencil"></span>
                    </a>
                  </div> -->
                </div>
                <div class="row">
                  <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Provenienza'"
                    [valueInput]="atto.provenienza?.descrizione"></div>
                  <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'date'" [labelInput]="'Data deposito'"
                    [valueInput]="atto.dataDeposito"></div>
                  <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'date'" [labelInput]="'Data notifica'"
                    [valueInput]="atto.dataNotifica"></div>
                </div>
                <div class="row">
                  <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'boolean'"
                    [labelInput]="'Titolo esecutivo'" [valueInput]="atto.titoloEsecutivo"></div>
                  <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'date'"
                    [labelInput]="'Data apposizione formula esecutiva'"
                    [valueInput]="atto.dataApposizioneFormulaEsecutiva"></div>
                </div>
                <div class="row">
                  <div class="col-sm-12 bloccodati">
                    <p>
                      <label class="col-sm-12 padding-note">Note</label> <span class="longtext">{{ atto.note
                        }}</span>
                    </p>
                  </div>
                </div>
                <div class="row mr-5">
                  <p class="col-sm-3 col-sm-offset-9 col-xs-4">
                    <button type="button" class="btn btn-primary btn-block" (click)="onEdit(i)" *ngIf="hasEditButton">Modifica dati</button>
                  </p>
                </div>
              </form>
            </li>
            <ng-template [ngIf]="atto.documenti.length > 0">
              <p>Documentazione allegata</p>
              <ul documenti_allegati_lista="" [documenti]="atto.documenti"
                [writable]="writable" [subdoc]="false"
                [nomeCampoId]="nomeCampoId"
                [fascicolo]="fascicolo"
                (onReturn)="onReturnUpdateCallback($event)"
                (openModal)="showUploadNewVersionModal($event)"
                (openHistoryModal)="showHistoryModal($event)"
                (removDoc)="removeDoc($event, atto.id)"
                (onOpenUpdateMetadatiModal)="displayDocUpdateMetadatiModal($event)">
              </ul>
            </ng-template>
          </ul>
        </li>
      </ng-template>
    </ul>
  </ng-template>
  <div class="tab-content" *ngIf="atti && atti.length == 0 && !hasAssociaButton">
    <p>Nessun atto è stato ancora inserito.</p>
  </div>
</div>
